// news
var catID = null;
var news_offset = 0;

// events
var events_offset = 0;
var eventType = null;
var eventCountry = null;
var eventDate = null;

//var
var shopper_offset = 0;

var category_search_offset = 0;

var practices_offset = 0;
var practices_posts_per_page = 3;
var practices_search_offset = 0;

var catalogCountry = null;

//promotions solutions
var promotions_promotions_offset = 0;
var promotions_moments_offset = 0;

var press_releases_offset = 0;

(function ($) {

    $(document).ready(function () {

        var body = $('body');

        // News load more-----------------------------------------------------------
        body.on("click", '#load_more_news', function (e) {
            e.preventDefault();
            setTimeout(function () {

                if (!$('#news-cat-filter').val()) {
                    var newsCount = $('.news-article').length;
                    news_offset = newsCount;
                    newsLoadMore(news_offset);
                } else {
                    var newsCount = $('.news-article').length - 1;
                    news_offset = newsCount;
                    newsLoadMore(news_offset, catID);
                }

            }, 10);

        });

        body.on('change', '#news-cat-filter', function (e) {
            e.preventDefault();
            //console.log(this.value);
            catID = this.value;
            news_offset = 0;
            newsCatFilter(news_offset, catID);
        });

        body.on('click', '.JS--clear-news-filter', function (e) {
            e.preventDefault();
            setTimeout(function () {

                if ($('#news-cat-filter').val()) {
                    $('#news-cat-filter').val($("#news-cat-filter option:first").val());
                    newsClearFilter();
                } else {

                }
            }, 10);
        });

        // End News load more-----------------------------------------------------------


        // Fairs Events load more-----------------------------------------------------------
        var eventsTypeSelect = $('#filter-events-type');
        var eventsCountrySelect = $('#filter-events-country');
        var eventsDateSelect = $('#filter-events-date');
        eventsTypeSelect.val($("#filter-events-type option:first").val());
        eventsCountrySelect.val($("#filter-events-country option:first").val());
        eventsDateSelect.val($("#filter-events-date option:first").val());

        body.on('change', '#filter-events-type', function (e) {
            e.preventDefault();
            eventType = this.value;
            eventCountry = (!$('#filter-events-country').val()) ? null : $("#filter-events-country option:selected").val();
            eventDate = (!$('#filter-events-date').val()) ? null : $('#filter-events-date option:selected').val();

            eventsFilters(0, eventType, eventCountry, parseInt(eventDate));
        });

        body.on('change', '#filter-events-country', function (e) {
            e.preventDefault();
            eventType = (!$('#filter-events-type').val()) ? null : $("#filter-events-type option:selected").val();
            eventCountry = this.value;
            eventDate = (!$('#filter-events-date').val()) ? null : $('#filter-events-date option:selected').val();

            eventsFilters(0, eventType, eventCountry, parseInt(eventDate));

        });

        body.on('change', '#filter-events-date', function (e) {
            e.preventDefault();
            eventType = (!$('#filter-events-type').val()) ? null : $("#filter-events-type option:selected").val();
            eventCountry = (!$('#filter-events-country').val()) ? null : $("#filter-events-country option:selected").val();
            eventDate = this.value;


            if(parseInt(eventDate) !== 0){
                eventsTypeSelect.prop('disabled', false);
                eventsCountrySelect.prop('disabled', false);
                eventsFilters(0, eventType, eventCountry, parseInt(eventDate));
            }else{
                eventsTypeSelect.prop('selectedIndex', 0);
                eventsCountrySelect.prop('selectedIndex', 0);
                eventsTypeSelect.prop('disabled', 'disabled');
                eventsCountrySelect.prop('disabled', 'disabled');
                eventsFilters(0, null, null, parseInt(eventDate));

            }

        });

        body.on('click', '.JS--clear-filter-events', function (e) {
            e.preventDefault();
            $('#empty-search-results').css('visibility', 'hidden');
            setTimeout(function () {
                if (eventsTypeSelect.val() || eventsCountrySelect.val() || eventsDateSelect.val()) {
                    eventsTypeSelect.val($("#filter-events-type option:first").val());
                    eventsCountrySelect.val($("#filter-events-country option:first").val());
                    eventsDateSelect.val($("#filter-events-date option:first").val());

                    eventsTypeSelect.prop('disabled', false);
                    eventsCountrySelect.prop('disabled', false);

                    eventsFilters(0);
                }


            }, 10);
        });

        body.on("click", '#load-more-events', function (e) {
            e.preventDefault();
            setTimeout(function () {
                var eventsCount = $('.events-article').length;
                events_offset = eventsCount;

                eventType = (!$('#filter-events-type').val()) ? null : $("#filter-events-type option:selected").val();
                eventCountry = (!$('#filter-events-country').val()) ? null : $("#filter-events-country option:selected").val();
                eventDate = (!$('#filter-events-date').val()) ? null : $('#filter-events-date option:selected').val();

                eventsLoadMore(events_offset, eventType, eventCountry, parseInt(eventDate));
            }, 1);
        });

        // End Fairs Events load more-----------------------------------------------------------


        // Shopper load more ---------------------------------------------------------------

        body.on('click', '#load-more-shoppers', function (e) {
            e.preventDefault();

            setTimeout(function () {
                var shopperPosts = $('.JS--shopper-article').length;
                shopper_offset = shopperPosts;
                shopperLoadMore(shopper_offset);
            }, 1);
        });

        // End Shopper load more ---------------------------------------------------------------

        // Press Releases load more ---------------------------------------------------------------

        body.on('click', '#load-more-press-releases', function (e) {
            e.preventDefault();

            setTimeout(function () {
                var releasesCount = $('.JS--press-releases').length;
                press_releases_offset = releasesCount;
                pressReleasesLoadMore(press_releases_offset);
            }, 1);
        });

        // End Press Releases load more ---------------------------------------------------------------

        // Best practices load more ---------------------------------------------------------------
        body.on('click', '#load-more-practices', function (e) {
            e.preventDefault();

            setTimeout(function () {

                if (!$('#best-practices-cat-filter').val()) {
                    var practicesPosts = $('.JS--best-practices-item').length;
                    practices_offset = practicesPosts;
                    bestPracticesLoadMore(practices_offset);
                } else {
                    var practicesPosts = $('.JS--best-practices-item').length;
                    practices_offset = practicesPosts;
                    bestPracticesLoadMore(practices_offset, catID);
                }

            }, 10);
        });

        // body.on('change', '#best-practices-cat-filter', function (e) {
        //     e.preventDefault();
        //     //console.log(this.value);
        //     catID = this.value;
        //     practices_offset = 0;
        //     bestPracticesCatFilter(practices_offset, catID);
        // });

        body.on("click", '#search-practices', function (e) {
            e.preventDefault();
            var search_best_practices = $("[name='search-best-practices']").val();
            if (!search_best_practices) {
                return false;
            }
            searchBestPractices(search_best_practices);
        });

        // body.on('click', '.JS--clear-best-practices-filter', function (e) {
        //     e.preventDefault();
        //     setTimeout(function () {

        //         if ($('#best-practices-cat-filter').val()) {
        //             $('#best-practices-cat-filter').val($("#best-practices-cat-filter option:first").val());
        //             bestPracticesClearFilter();
        //         } else {

        //         }
        //     }, 10);
        // });

        body.on("click", '#clear-more-best-practices', function (e) {
            e.preventDefault();
            $("[name='search-best-practices']").val('');
            practices_search_offset = 0;
            clearBestPractices(0);
        });

        body.on("click", '#search-more-practices', function (e) {
            e.preventDefault();
            var serch_practices_term = $("[name='search-best-practices']").val();
            if (!serch_practices_term) {
                return false;
            }
            var searchPosts = $('.JS--shopper-article').length;
            practices_search_offset = searchPosts;
            searchLoadMoreBestPractices(practices_search_offset, serch_practices_term);
        });

        // End Best practices load more ---------------------------------------------------------------

        // Catalog Filter ---------------------------------------------------------------

        body.on('change', '.JS--catalog-filter', function (e) {
            e.preventDefault();
            if (this.checked) {
                catalogFilter(this.value);
            }

        });

        body.on('click', '.JS--clear-catalog-filter', function (e) {
            e.preventDefault();
            $('.JS--catalog-filter').prop("checked", false);
            catalogFilter();
        });

        // End Catalog Filter ---------------------------------------------------------------

        //shopper search ---------------------------------------------------------------
        body.on("click", '#search-shopper', function (e) {
            e.preventDefault();
            var serch_term = $("[name='search-category-management']").val();
            if (!serch_term) {
                return false;  
            } 
            searchCategoryManagement(serch_term);
        });
        //shopper search load more ---------------------------------------------------------------
        body.on("click", '#search-more-shoppers', function (e) {
            e.preventDefault();
            var serch_term = $("[name='search-category-management']").val();
            if (!serch_term) {
                return false;  
            } 
            var searchPosts = $('.JS--shopper-article').length;
            category_search_offset = searchPosts;
            searchLoadMoreCategoryManagement(category_search_offset, serch_term);
        });
        //clear search the-banana-shopper-mindset
        body.on("click", '#clear-more-shoppers', function (e) {
            e.preventDefault();
            $("[name='search-category-management']").val('');
            category_search_offset = 0;
            clearCategoryManagement(0);
        });

        //promotions solutions ---------------------------------------------------------------
        
        body.on('click', '#load-more-promotions-promotions', function (e) {
            e.preventDefault();
            catID = $(this).attr("data-cat-id");
            setTimeout(function () {
                var promototionsPosts = $('.JS--promotions-promotions-posts > div').length;
                promotions_promotions_offset = promototionsPosts;
                promotionsLoadMore(promotions_promotions_offset, catID);
            }, 1);
        });

        body.on('click', '#load-more-promotions-moments', function (e) {
            e.preventDefault();
            catID = $(this).attr("data-cat-id");
            setTimeout(function () {
                var promototionsPosts = $('.JS--promotions-moments-posts > div').length;
                promotions_moments_offset = promototionsPosts;
                promotionsMomentsLoadMore(promotions_moments_offset, catID);
            }, 1);
        });

        //end of promotions solutions ---------------------------------------------------------------

    }); // end document ready


    // Catalog Filter Ajax ---------------------------------------------------------------
    function catalogFilter(catalogCountry) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_catalog_posts",
                catalogCountry: catalogCountry
            },
            type: 'POST',
            success: function (data) {
                // Append results to DOM
                $(".JS--display-catalog-loop").html('');
                $(".JS--display-catalog-loop").append(data);
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    // End Catalog Filter Ajax ---------------------------------------------------------------

    // News load more ---------------------------------------------------------------

    function newsLoadMore(news_offset, catID) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_news",
                termID: catID,
                offset: news_offset
            },
            type: 'POST',
            beforeSend: function () {
                $('#load_more_news').append('<span class="c-primary-button-icon-loading"></span>');
            },
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#load_more_news").fadeOut();
                    return false;
                }
                var result = data.data;
                // Append results to DOM
                if (result.success != false) {
                    $(".news-loop").append(result.content);
                }
                if (result.success == false || result.load_button == false || data.success == false) {
                    $("#load_more_news").fadeOut();
                }

            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function newsCatFilter(news_offset, catID) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_news",
                termID: catID,
                offset: news_offset
            },
            type: 'POST',
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#load_more_news").fadeOut();
                    return false;
                }
                var result = data.data;
                // Append results to DOM
                if (result.success != false) {
                    $(".news-loop").html('');
                    $(".news-loop").append(result.content);
                }
                if (result.success == false || result.load_button == false || data.success == false) {
                    $("#load_more_news").fadeOut();
                } else if (result.load_button == false) {
                    $("#load_more_news").fadeIn();
                }  
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function newsClearFilter() {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_news",
                offset: 1
            },
            type: 'POST',
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#load_more_news").fadeOut();
                    return false;
                }
                var result = data.data;
                // Append results to DOM
                if (result.success != false) {
                    $(".news-loop").html('');
                    $(".news-loop").append(result.content);
                }
                if (result.success == false || result.load_button == false || data.success == false) {
                    $("#load_more_news").fadeOut();
                } else if (result.load_button == true) {
                    $("#load_more_news").fadeIn();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    // End News load more ---------------------------------------------------------------


    // Fairs Events load more ---------------------------------------------------------------

    function eventsLoadMore(events_offset, eventType, eventCountry, eventDate) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_events",
                offset: events_offset,
                eventType: eventType,
                eventCountry: eventCountry,
                eventDate: eventDate,
            },
            type: 'POST',
            beforeSend: function () {
                $('#load-more-events').append('<span class="c-primary-button-icon-loading"></span>');
            },
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#load-more-events").fadeOut();
                    return false;
                }
                var result = data.data;
                // Append results to DOM
                if (result.success != false) {
                    $(".events-loop").append(result.content);
                }
                if (result.success == false || result.load_button == false || data.success == false) {
                    $("#load-more-events").fadeOut();
                } else if (result.load_button == true) {
                    $("#load-more-events").fadeIn();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function eventsFilters(events_offset, eventType, eventCountry, eventDate) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_events",
                offset: events_offset,
                eventType: eventType,
                eventCountry: eventCountry,
                eventDate: eventDate,
            },
            type: 'POST',
            beforeSend: function () {
                $('#empty-filter-results').css('visibility', 'hidden');
            },
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $(".JS--fair-events-posts").html('');
                    $("#empty-filter-results").css({ opacity: 0.0, visibility: "visible" }).animate({ opacity: 1.0 });
                    $("#load-more-events").fadeOut(0);
                    return false;
                }
                var result = data.data;
                // Append results to DOM
                if (result.success != false) {
                    $(".events-loop").html('');
                    $(".events-loop").append(result.content);
                }
                if (result.success == false || result.load_button == false || data.success == false) {
                    $("#load-more-events").fadeOut(0);
                } else if (result.load_button == true) {
                    $("#load-more-events").fadeIn();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }


    // End Fairs Events load more ---------------------------------------------------------------

    // Shopper load more ---------------------------------------------------------------

    function shopperLoadMore(shopper_offset) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_shopper",
                shopper_offset: shopper_offset
            },
            type: 'POST',
            beforeSend: function () {
                $('#load-more-shoppers').append('<span class="c-primary-button-icon-loading"></span>');
            },
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#load-more-shoppers").fadeOut();
                    return false;
                }
                var result = data.data;
                if (result.success != false) {
                    $(".JS--shopper-posts").append(result.content);
                }
                // Append results to DOM
                if (result.success == false || result.load_button == false || data.success == false) {
                    $("#load-more-shoppers").fadeOut();
                } else if (result.load_button != false) {
                    $("#load-more-shoppers").fadeIn();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    // Fairs Shopper load more ---------------------------------------------------------------


    // Best practices load more ---------------------------------------------------------------

    function bestPracticesLoadMore(practices_offset,catID) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_practices",
                catID: catID,
                practices_offset: practices_offset
            },
            type: 'POST',
            beforeSend: function () {
                $('#load-more-practices').append('<span class="c-primary-button-icon-loading"></span>');
            },
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#load-more-practices").fadeOut();
                    return false;
                }
                var result = data.data;
                    if (result.success != false) {
                        $(".JS--best-practices-posts").append(result.content);
                    }
                // Append results to DOM
                if (result.success == false || result.load_button == false || data.success == false){
                    $("#load-more-practices").fadeOut();
                } else if (result.load_button != false) {
                    $("#load-more-practices").fadeIn();
                }

                // if (!Boolean(data)) {
                //     $('#load-more-practices').addClass('is-disabled');
                // } else {
                //     $('#load-more-practices').removeClass('is-disabled');
                // }

            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    // function bestPracticesCatFilter(practices_offset, catID) {
    //     $.ajax({
    //         url: ajaxurl,
    //         data: {
    //             action: "fetch_practices",
    //             catID: catID,
    //             practices_offset: practices_offset
    //         },
    //         type: 'POST',
    //         success: function (data) {
    //             $('.c-primary-button-icon-loading').remove();
    //             if (!data.success) {
    //                 $("#load-more-practices").fadeOut();
    //                 return false;
    //             }
    //             var result = data.data;
    //             // Append results to DOM
    //             if (result.success != false) {
    //                 $(".JS--best-practices-posts").html('');
    //                 $(".JS--best-practices-posts").append(result.content);
    //             }
    //             if (result.success == false || result.load_button == false) {
    //                 $("#load-more-practices").fadeOut();
    //             } else if (result.load_button != false) {
    //                 $("#load-more-practices").fadeIn();
    //             }
    //         },
    //         error: function (errorThrown) {
    //             console.log(errorThrown);
    //         }
    //     });
    // }

    // function bestPracticesClearFilter() {
    //     $.ajax({
    //         url: ajaxurl,
    //         data: {
    //             action: "fetch_practices",
    //             practices_offset: 0
    //         },
    //         type: 'POST',
    //         success: function (data) {
    //             $('.c-primary-button-icon-loading').remove();
    //             if (!data.success) {
    //                 $("#load-more-practices").fadeOut();
    //                 return false;
    //             }
    //             var result = data.data;
    //             // Append results to DOM
    //             if (result.success != false) {
    //                 $(".JS--best-practices-posts").html('');
    //                 $(".JS--best-practices-posts").append(result.content);
    //             }

    //             if (result.success == false || result.load_button == false) {
    //                 $("#load-more-practices").fadeOut();
    //             } else if (result.load_button != false) {
    //                 $("#load-more-practices").fadeIn();
    //             }
    //         },
    //         error: function (errorThrown) {
    //             console.log(errorThrown);
    //         }
    //     });
    // }

    function searchBestPractices(term) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "chiquita_search_best_practices",
                term: term,
            },
            type: 'POST',
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                
                if (!data.success) {
                    $("#empty-search-results").css({ opacity: 0.0, visibility: "visible" }).animate({ opacity: 1.0 });
                    return false;
                }
                var result = data.data;
                // Append results to DOM
                if (result.success != false) {
                    $("#load-more-practices").hide();
                    $('#empty-search-results').css('visibility', 'hidden');
                    $(".JS--best-practices-posts").html('');
                    $(".JS--best-practices-posts").append(result.content);
                }

                if (result.success == false || result.load_button == false) {
                    $("#search-more-practices").hide();
                } else if (result.load_button != false) {
                    $("#search-more-practices").fadeIn();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function clearBestPractices(shopper_offset) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_practices",
                shopper_offset: shopper_offset
            },
            type: 'POST',
            beforeSend: function () {
                $('#empty-search-results').css('visibility', 'hidden');
                //$('#load-more-practices').append('<span class="c-primary-button-icon-loading"></span>');
            },
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                $("#search-more-practices").hide();
                if (!data.success) {
                    $("#load-more-practices").hide();
                    return false;
                }
                var result = data.data;
                if (result.success != false) {
                    $(".JS--best-practices-posts").html('');
                    $(".JS--best-practices-posts").append(result.content);
                }
                // Append results to DOM
                if (result.success == false || result.load_button == false || data.success == false) {
                    $("#load-more-practices").fadeOut();
                } else if (result.load_button != false) {
                    $("#load-more-practices").fadeIn();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function searchLoadMoreBestPractices(offset, term) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "chiquita_search_best_practices",
                term: term,
                search_offset: offset,
            },
            type: 'POST',
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#load-more-practices").fadeOut();
                    return false;
                }
                var result = data.data;
                // Append results to DOM
                if (result.success != false) {
                    $(".JS--best-practices-posts").append(result.content);
                }

                if (result.success == false || result.load_button == false) {
                    $("#search-more-practices").fadeOut();
                } else if (result.load_button != false) {
                    $("#search-more-practices").fadeIn();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });

    }
    // End Best practices load more ---------------------------------------------------------------

    function searchCategoryManagement(term) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "search_category_management",
                term: term,
            },
            type: 'POST',
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#empty-search-results").css({ opacity: 0.0, visibility: "visible" }).animate({opacity: 1.0});
                    return false;
                }
                var result = data.data;
                // Append results to DOM
                if (result.success != false) {
                    $("#load-more-shoppers").hide();
                    $('#empty-search-results').css('visibility', 'hidden');
                    $(".JS--shopper-posts").html('');
                    $(".JS--shopper-posts").append(result.content);
                }

                if (result.success == false || result.load_button == false) {
                    $("#search-more-shoppers").hide();
                } else if (result.load_button != false) {
                    $("#search-more-shoppers").fadeIn();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
        
    }

    function searchLoadMoreCategoryManagement(offset, term) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "search_category_management",
                term: term,
                search_offset: offset,
            },
            type: 'POST',
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#load-more-shoppers").fadeOut();
                    return false;
                }
                var result = data.data;
                // Append results to DOM
                if (result.success != false) {
                    $(".JS--shopper-posts").append(result.content);
                }

                if (result.success == false || result.load_button == false) {
                    $("#search-more-shoppers").fadeOut();
                } else if (result.load_button != false) {
                    $("#search-more-shoppers").fadeIn();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
        
    }

    function clearCategoryManagement(shopper_offset) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_shopper",
                shopper_offset: shopper_offset
            },
            type: 'POST',
            beforeSend: function () {
                $('#empty-search-results').css('visibility', 'hidden');
                //$('#load-more-shoppers').append('<span class="c-primary-button-icon-loading"></span>');
            },
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                $("#search-more-shoppers").hide();
                if (!data.success) {
                    $("#load-more-shoppers").hide();
                    return false;
                }
                var result = data.data;
                if (result.success != false) {
                    $(".JS--shopper-posts").html('');
                    $(".JS--shopper-posts").append(result.content);
                }
                // Append results to DOM
                if (result.success == false || result.load_button == false || data.success == false) {
                    $("#load-more-shoppers").hide();
                } else if (result.load_button != false) {
                    $("#load-more-shoppers").fadeIn();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    function promotionsLoadMore(promotions_offset, catID) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_promotions",
                catID: catID,
                promotions_offset: promotions_offset
            },
            type: 'POST',
            beforeSend: function () {
                $('#load-more-promotions-promotions').append('<span class="c-primary-button-icon-loading"></span>');
            },
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#load-more-promotions-promotions").fadeOut();
                    return false;
                }
                var result = data.data;
                if (result.success != false) {
                    $(".JS--promotions-promotions-posts").append(result.content);
                }
                // Append results to DOM
                if (result.success == false || result.load_button == false || data.success == false) {
                    $("#load-more-promotions-promotions").fadeOut();
                } else if (result.load_button != false) {
                    $("#load-more-promotions-promotions").fadeIn();
                }

                // if (!Boolean(data)) {
                //     $('#load-more-practices').addClass('is-disabled');
                // } else {
                //     $('#load-more-practices').removeClass('is-disabled');
                // }

            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }
    
    function promotionsMomentsLoadMore(promotions_offset, catID) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_promotions",
                catID: catID,
                promotions_offset: promotions_offset
            },
            type: 'POST',
            beforeSend: function () {
                $('#load-more-promotions-moments').append('<span class="c-primary-button-icon-loading"></span>');
            },
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#load-more-promotions-moments").fadeOut();
                    return false;
                }
                var result = data.data;
                if (result.success != false) {
                    $(".JS--promotions-moments-posts").append(result.content);
                }
                // Append results to DOM
                if (result.success == false || result.load_button == false || data.success == false) {
                    $("#load-more-promotions-moments").fadeOut();
                } else if (result.load_button != false) {
                    $("#load-more-promotions-moments").fadeIn();
                }

                // if (!Boolean(data)) {
                //     $('#load-more-practices').addClass('is-disabled');
                // } else {
                //     $('#load-more-practices').removeClass('is-disabled');
                // }

            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    //Press Releases load more ---------------------------------------------------------------

    function pressReleasesLoadMore(press_releases_offset) {
        $.ajax({
            url: ajaxurl,
            data: {
                action: "fetch_press_releases",
                press_releases_offset: press_releases_offset
            },
            type: 'POST',
            beforeSend: function () {
                $('#load-more-press-releases').append('<span class="c-primary-button-icon-loading"></span>');
            },
            success: function (data) {
                $('.c-primary-button-icon-loading').remove();
                if (!data.success) {
                    $("#load-more-press-releases").fadeOut();
                    return false;
                }
                var result = data.data;
                if (result.success != false) {
                    $(".JS--press-releases-content").append(result.content);
                }
                // Append results to DOM
                if (result.success == false || result.load_button == false || data.success == false) {
                    $("#load-more-press-releases").fadeOut();
                } else if (result.load_button != false) {
                    $("#load-more-press-releases").fadeIn();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

    //Press Releases load more ---------------------------------------------------------------


})(jQuery);